import { useEffect, useState } from "react";
import { api, mediaUrl } from "@/lib/api";
import { Reveal, ChapterBadge } from "@/components/Reveal";

export default function ClientGrid() {
  const [clients, setClients] = useState(null);

  useEffect(() => {
    api.get("/clients").then((r) => setClients(r.data)).catch(() => setClients([]));
  }, []);

  const withLogos = (clients || []).filter((c) => c.logo_path);
  if (!clients || withLogos.length === 0) return null;

  return (
    <section data-testid="client-grid" className="py-20 sm:py-24 border-t border-charcoal-900/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ChapterBadge number="" label="Associations" />
        <Reveal className="mt-8">
          <h2 className="font-serif text-3xl sm:text-4xl tracking-tight text-charcoal-900 leading-[1.1]">
            Companies &amp; <em className="italic text-copper-600">Brands.</em>
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {withLogos.map((c, i) => (
            <Reveal key={c.id} delay={Math.min(i * 0.05, 0.3)}>
              <div
                data-testid={`client-logo-${i}`}
                className="group aspect-square bg-surface-white border border-charcoal-900/10 rounded-2xl overflow-hidden hover:border-copper-600/30 hover:shadow-lg transition-[box-shadow,border-color] duration-300"
              >
                <img
                  src={`${mediaUrl(c.logo_thumb_path || c.logo_path)}?thumb=1`}
                  alt={c.name}
                  title={c.name}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
